/*! modernizr 3.5.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-touchevents-video-websockets-webworkers-setclasses !*/
!function(e,n,o){function t(e,n){return typeof e===n}function a(){var e,n,o,a,s,i,r;for(var c in d)if(d.hasOwnProperty(c)){if(e=[],n=d[c],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(o=0;o<n.options.aliases.length;o++)e.push(n.options.aliases[o].toLowerCase());for(a=t(n.fn,"function")?n.fn():n.fn,s=0;s<e.length;s++)i=e[s],r=i.split("."),1===r.length?Modernizr[r[0]]=a:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=a),l.push((a?"":"no-")+r.join("-"))}}function s(e){var n=v.className,o=Modernizr._config.classPrefix||"";if(h&&(n=n.baseVal),Modernizr._config.enableJSClass){var t=new RegExp("(^|\\s)"+o+"no-js(\\s|$)");n=n.replace(t,"$1"+o+"js$2")}Modernizr._config.enableClasses&&(n+=" "+o+e.join(" "+o),h?v.className.baseVal=n:v.className=n)}function i(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):h?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function r(){var e=n.body;return e||(e=i(h?"svg":"body"),e.fake=!0),e}function c(e,o,t,a){var s,c,l,d,f="modernizr",p=i("div"),u=r();if(parseInt(t,10))for(;t--;)l=i("div"),l.id=a?a[t]:f+(t+1),p.appendChild(l);return s=i("style"),s.type="text/css",s.id="s"+f,(u.fake?u:p).appendChild(s),u.appendChild(p),s.styleSheet?s.styleSheet.cssText=e:s.appendChild(n.createTextNode(e)),p.id=f,u.fake&&(u.style.background="",u.style.overflow="hidden",d=v.style.overflow,v.style.overflow="hidden",v.appendChild(u)),c=o(p,e),u.fake?(u.parentNode.removeChild(u),v.style.overflow=d,v.offsetHeight):p.parentNode.removeChild(p),!!c}var l=[],d=[],f={_version:"3.5.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var o=this;setTimeout(function(){n(o[e])},0)},addTest:function(e,n,o){d.push({name:e,fn:n,options:o})},addAsyncTest:function(e){d.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=f,Modernizr=new Modernizr;var p=!1;try{p="WebSocket"in e&&2===e.WebSocket.CLOSING}catch(u){}Modernizr.addTest("websockets",p);var v=n.documentElement,h="svg"===v.nodeName.toLowerCase(),m=f._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];f._prefixes=m,Modernizr.addTest("video",function(){var e=i("video"),n=!1;try{n=!!e.canPlayType,n&&(n=new Boolean(n),n.ogg=e.canPlayType('video/ogg; codecs="theora"').replace(/^no$/,""),n.h264=e.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/,""),n.webm=e.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/,""),n.vp9=e.canPlayType('video/webm; codecs="vp9"').replace(/^no$/,""),n.hls=e.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/,""))}catch(o){}return n});var y=f.testStyles=c;Modernizr.addTest("touchevents",function(){var o;if("ontouchstart"in e||e.DocumentTouch&&n instanceof DocumentTouch)o=!0;else{var t=["@media (",m.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");y(t,function(e){o=9===e.offsetTop})}return o}),Modernizr.addTest("webworkers","Worker"in e),a(),s(l),delete f.addTest,delete f.addAsyncTest;for(var g=0;g<Modernizr._q.length;g++)Modernizr._q[g]();e.Modernizr=Modernizr}(window,document);

// Load jQuery
import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;
globalThis.$ = jQuery;
globalThis.jQuery = jQuery;

// Import bootstrap
import './bootstrap'; 

// Import toastr
import toastr from 'toastr';
window.toastr = window.Toastr = toastr;
toastr.options = {
    closeButton: true,
    debug: false,
    progressBar: true,
    preventDuplicates: false,
    positionClass: "toast-top-center",
    onclick: null,
    showDuration: "400",
    hideDuration: "1000",
    timeOut: "7000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut"
};

// Import moment
import momentImport from 'moment/min/moment-with-locales';
const moment = momentImport.default || momentImport;
window.moment = moment;
if (typeof moment.locale === 'function') {
  moment.locale('it');
} else {
  console.error('Import di moment non è la funzione attesa:', momentImport);
}

// Load plugins jQuery after $ is global (dynamic import)
(async () => {
    // Bootstrap 3 (bootstrap-sass)
    await import('bootstrap-sass/assets/javascripts/bootstrap');

    await import('select2');
    await import('jquery-bootstrap-scrolling-tabs'); 
    await import('blueimp-gallery/js/blueimp-gallery');
    await import('blueimp-gallery/js/jquery.blueimp-gallery');

    await import('vaguejs/Vague.js');
    const Vague = window.Vague;
    window.Vague = Vague;
 
    await import('./vendor/metisMenu/jquery.metisMenu');
    await import('./vendor/slimscroll/jquery.slimscroll.min');
    
    await import('bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js');
    await import('bootstrap-datepicker/dist/locales/bootstrap-datepicker.it.min.js');
    await import('./vendor/bootstrap-datetimepicker/bootstrap-datetimepicker.min');

    await import('./inspinia');
    await import('./jasny-bootstrap.min');

    await import('./locale');
    await import('./ujs');
    await import('./subscriptions');
    //await import('./websocket');

    //import 'babel-polyfill';
})();

import swal from 'sweetalert2'
window.swal = swal;

import Pace from 'pace-progress';
Pace.start();

import * as XLSX from 'xlsx';
window.XLSX = XLSX;

import Masonry from 'masonry-layout';
window.Masonry = Masonry;

import CodeMirror from 'codemirror';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/htmlmixed/htmlmixed.js';
import 'codemirror/addon/display/autorefresh.js';
window.CodeMirror = CodeMirror;

window.AgiConnect = window.AgiConnect || {};
